module.exports = __webpack_public_path__ + "static/UnclickDamageLoss-845375b58121c5fa2919729cb13f52cb.png";